module.exports = __webpack_public_path__ + "img/ibank.360c40d6.png";